// extracted by mini-css-extract-plugin
export default {"l":"_3e6f0884c0"};